/**
 * APP配置
 */

// 环境配置
// 开发
export const isDev = process.env.NODE_ENV === 'development';

// 生产
export const isProd = process.env.NODE_ENV === 'production';

// 后台的i18标识
export const localeMap = {
    en: 'en',
    'zh-Hant': 'tc',
    'zh-Hans': 'cn',
    ja: 'jpy',
    th: 'Thai',
    ko: 'ko',
    id: 'id',
    it: 'it',
    de: 'de',
    'en-GB': 'en-GB'
};

// 语言
export const localeList = {
    en: {
        title: 'English'
    },
    'en-GB': {
        title: 'English (UK)'
    },
    // th: {
    //   title: "ไทย",
    // },
    ja: {
        title: '日本語'
    },
    ko: {
        title: '한국어'
    },
    // id: {
    //   title: "Bahasa Indonesia",
    // },
    it: {
        title: 'Italiano'
    },
    de: {
        title: 'Deutsch'
    },
    'zh-Hant': {
        title: '繁體中文'
    }
};

// 系统配置
export const appSystemConfig = (() => {
    const config = {
        name: 'PSH',
        logo: '/static/images/logo.png',
        // #ifdef APP-PLUS
        platform: plus.os.name,
        // #endif
        // #ifdef H5
        platform: 'H5',
        // #endif
        // #ifdef MP
        platform: 'MINI',
        // #endif
        version: '1.0.0',
        areaCode: '82',
        features: {
            isLever: false, //是否杠杆,
            isTopUpUSDT: true, // usdt充值
            isDownloadApp: false, // 下载app
            isMembershipTagShow: true, // 是否展示会员
            isSMSCodeAuth: false, // 是否验证码登录
            isCryptoWithdraw: true, // 是否虚拟币提现
            isPayPassword: false, // 支付密码
            isService: true, // 客服
            isLoanSign: true // 是否需要签名
        }
    };

    return config;
})();

// 域名
export const baseURL = (() => {
    if (isDev) {
        // return "https://test-api.testalb.top";
        // return "https://v1-api.baeddev.com";
        // 同源相对路径，走 vite proxy（/ai -> 去掉前缀后转发后端），避免写死端口
        return '/ai';
    } else {
        return '';
    }
})();

// wss
export const socketURL = (() => {
    if (isDev) {
        return 'wss://test-ws.testaxxaa.top/ws';
    } else {
        return `wss://${location.host}/ws`;
    }
})();

// 在线客服地址
export const serviceLink = '';
